import { useMemo } from 'react'

//* Components
import Container from 'components/common/Container'

//* Style
import DangerDescriptionStyle from './style'

const DangerDescription = ({ descriptions }) => {
    const storeSecondSectionDescriptions = useMemo(() => {
        return descriptions?.map((description, index) => (
            <div key={index} className={'description'} dangerouslySetInnerHTML={{ __html: description }} />
        ))
    }, [descriptions])

    return (
        <DangerDescriptionStyle>
            <Container section>
                <div className='descriptions-wrap'>{storeSecondSectionDescriptions}</div>
            </Container>
        </DangerDescriptionStyle>
    )
}

export default DangerDescription
